function arrivalDate(today, days, working) {
  const date = new Date(today + 'T12:00:00Z');
  let count = 0;
  while (count < days) {
    date.setUTCDate(date.getUTCDate() + 1);
    if (!working || (date.getUTCDay() !== 0 && date.getUTCDay() !== 6)) count++;
  }
  return date.toISOString().slice(0, 10);
}

class AuziProductArrival extends HTMLElement {
  connectedCallback() {
    this.root = this.closest('product-info');
    this.variants = JSON.parse(this.querySelector('[data-arrival-variants]')?.textContent || '[]');
    this.card = this.querySelector('[data-arrival-card]');
    this.preorder = this.querySelector('[data-arrival-preorder]');
    this.update = this.update.bind(this);
    this.root?.addEventListener('change', this.update);
    this.observer = new MutationObserver(this.update);
    if (this.root) this.observer.observe(this.root, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled','value']});
    this.timer = setInterval(this.update, 60000);
    this.update();
  }

  update() {
    const id = this.root?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    const variant = this.variants.find(item => String(item.id) === id);
    const unavailable = variant ? !variant.available : this.root?.querySelector('.product-form__submit')?.disabled;
    if (this.hidden !== Boolean(unavailable)) this.hidden = Boolean(unavailable);
    const preorder = this.dataset.hearloom === 'true' && variant?.preorder;
    if (this.card && this.card.hidden !== Boolean(preorder)) this.card.hidden = Boolean(preorder);
    if (this.preorder && this.preorder.hidden === Boolean(preorder)) this.preorder.hidden = !preorder;
    if (!this.card || this.dataset.digital === 'true' || preorder) return;
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()).map(part => [part.type,part.value]));
    const today = parts.year + '-' + parts.month + '-' + parts.day;
    const offsets = [Number(this.card.dataset.firstDays), Number(this.card.dataset.lastDays)];
    const dates = offsets.map(days => arrivalDate(today, days, this.card.dataset.workingDays === 'true'));
    const formatter = new Intl.DateTimeFormat(this.dataset.locale || 'en', {day:'numeric',month:'short',...(dates.some(date => date.slice(0,4) !== parts.year) ? {year:'numeric'} : {}),timeZone:'UTC'});
    this.card.querySelectorAll('time').forEach((element,index) => {
      const date = dates[index];
      const label = formatter.format(new Date(date + 'T12:00:00Z'));
      if (element.dateTime !== date) element.dateTime = date;
      if (element.textContent !== label) element.textContent = label;
    });
  }

  disconnectedCallback() {
    this.root?.removeEventListener('change', this.update);
    this.observer?.disconnect();
    clearInterval(this.timer);
  }
}
if (!customElements.get('auzi-product-arrival')) customElements.define('auzi-product-arrival', AuziProductArrival);
